import { useFormik } from "formik";
import Button from "../../../components/buttons/button";
import Switch from "../../../components/inputs/switch";

const NotificationsTab = ({ t }) => {
  const formik = useFormik({
    initialValues: {},
    onSubmit: (vals) => {
      console.log(vals);
    },
  });
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium text-mainGray">{t("notifications")}</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="p-4 space-y-4 rounded-2xl bg-sideBar"
      >
        <label
          htmlFor="request-vip"
          className="flex items-center justify-between p-4 rounded-lg cursor-pointer bg-mainBg"
        >
          <div>
            <p className="mb-4 font-semibold">{t("requestVipMembership")}</p>
            <p className="text-xs font-semibold text-mainGray">
              {t("vipNotification")}
            </p>
          </div>
          <Switch id="request-vip" formik={formik} name="request-vip" />
        </label>
        <label
          htmlFor="membership-expiry"
          className="flex items-center justify-between p-4 rounded-lg cursor-pointer bg-mainBg"
        >
          <div>
            <p className="mb-4 font-semibold">{t("memberShipExpiry")}</p>
            <p className="text-xs font-semibold text-mainGray">{t("7DayRemainder")}</p>
          </div>
          <Switch id="membership-expiry" formik={formik} name="membership-expiry" />
        </label>
        <Button className={"bg-primary flex justify-center text-black py-3"}>
          {t("save")}
        </Button>
      </form>
    </div>
  );
};

export default NotificationsTab;
